import React from 'react'
import ProfilePanel from './ProfilePanel'

function Field({ label, children }) {
  return (
    <div>
      <label className="block text-xs text-slate-500 mb-0.5">{label}</label>
      <span className="font-semibold text-sm text-slate-900">{children}</span>
    </div>
  )
}

export default function ProfilePatronDetailsCard({
  profileData,
  patronProfile,
  formatDateTime,
  onEditContact,
  canEditProfile,
}) {
  const email = (profileData?.Email || patronProfile?.email || '').trim()
  const phone = (profileData?.Phone || patronProfile?.phone || '').trim()
  const occupation = (profileData?.Occupation || patronProfile?.occupation || '').trim()
  const middleName = (
    profileData?.MDN ||
    profileData?.MN ||
    patronProfile?.middle_name ||
    ''
  ).trim()
  const addressLine =
    profileData?.CurrentAddress?.Address || profileData?.PrimaryAddress?.Address || null
  const suburbState =
    [
      profileData?.CurrentAddress?.Suburb || profileData?.PrimaryAddress?.Suburb,
      profileData?.CurrentAddress?.State || profileData?.PrimaryAddress?.State,
      profileData?.CurrentAddress?.PostalCode || profileData?.PrimaryAddress?.PostalCode,
    ]
      .filter(Boolean)
      .join(' ')

  const citizenship =
    Array.isArray(profileData?.CitizenshipCountries) && profileData.CitizenshipCountries.length > 0
      ? profileData.CitizenshipCountries.filter(Boolean).join(', ')
      : profileData?.Nationality || '—'

  return (
    <ProfilePanel
      title="Patron details"
      actions={
        canEditProfile ? (
          <button
            type="button"
            onClick={onEditContact}
            className="text-teal-700 text-xs font-semibold hover:underline bg-transparent border-0 cursor-pointer p-0"
          >
            Edit profile
          </button>
        ) : null
      }
    >
      <div className="grid grid-cols-3 gap-4 max-md:grid-cols-2">
        <Field label="Middle name">
          {middleName || <span className="text-slate-400 font-normal">Not on file</span>}
        </Field>
        <Field label="Date of birth">{profileData?.DOB || '—'}</Field>
        <Field label="Citizenship">{citizenship}</Field>
        <Field label="Email">
          {email || <span className="text-slate-400 font-normal">Not on file</span>}
        </Field>
        <Field label="Phone">
          {phone || <span className="text-slate-400 font-normal">Not on file</span>}
        </Field>
        <Field label="Occupation">
          {occupation || <span className="text-slate-400 font-normal">Not on file</span>}
        </Field>
        <Field label="Last updated">
          {formatDateTime(patronProfile?.last_import_at || patronProfile?.updated_at || profileData?.LUT)}
        </Field>
        <div className="col-span-2 max-md:col-span-2">
          <Field label="Address">
            {addressLine ? (
              <>
                {addressLine}
                {suburbState ? `, ${suburbState}` : ''}
              </>
            ) : (
              <span className="text-slate-400 font-normal">No address on record</span>
            )}
          </Field>
        </div>
      </div>
    </ProfilePanel>
  )
}
